import { typeCheck } from '../lib/util';
import loyaltyService from './loyaltyService';

/**
 * Loyalty API interface
 * @namespace Collaterate.Loyalty
 */

export default class LoyaltyAPI {
    /**
     * Get program details for site loyalty program
     * @param {string} apiKey - The API Key for the loyalty program you wish to grab details for
     * @returns {Promise<Collaterate.Loyalty~programDetails>}
     * @memberof Collaterate.Loyalty
     * @example
     * Collaterate.Loyalty.getProgram('ABCDEFG')
     *     .then(console.log);
     */

    static getProgram (apiKey) {
        typeCheck(apiKey, String);

        return loyaltyService.getProgram(apiKey);
    }
}

/**
 * Object containing auth details for this site's loyalty integration
 * @typedef {Object} Collaterate.Loyalty~programDetails
 * @property {string} name - The name of the loyalty program.
 * @property {boolean} enabled - Whether or not the loyalty program is enabled on this storefront.
 * @property {string} pointsLabel - The label used for this storfront's loyalty points.
 * @property {string} dollarToPointsRate - The dollar-to-point conversion rate.
 * @property {string} pointsToDollarsRate - The point-to-dollar conversion rate.
 * @property {string} pointsExpirationDays - The number of days after which points expire.
 * @property {string} signUpBonus - The number of points awarded to new users.
 * @property {Collaterate.Loyalty~tier[]} tiers - An array of tiers for the loyalty program.
 */

/**
 * Object containing details for a loyalty tier.
 * @typedef {Object} Collaterate.Loyalty~tier
 * @property {string} tierId - The id of the tier.
 * @property {string} name - The name of the tier.
 * @property {string} color - The color of the tier.
 * @property {string} code - The code of the tier.
 * @property {string} requiredSpend - The amount of points required to reach this tier.
 * @property {string} pointsMultiplier - The multiplier for points awarded for this tier.
 */
